<template>
    <div>
        <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryDatabaseByGroupIdList" style="width: 100.1%;">
            <template slot-scope="{row,index}" slot="actions">
                <span @click="doDelete(index)">
                    <Button type="error" size="small" @click="databaseDelModal = true">{{ $t('alarms.common.delete') }}</Button>
                </span>
            </template>
        </Table>
        <br>

        <Modal v-model="databaseDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }} {{Name}} {{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="deleteDatabase()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>

    var tableDatabases = {}
    export default {
        name: 'TableDatabases',
        data () {
            return {
                Name: '',
                modalLoading: true,
                databaseDelModal: false,
                isDisable: false,
                columns: [
                {
                    title: this.$t('alarms.database.databaseId'),
                    key: 'databaseId'
                },
                {
                    title: this.$t('alarms.database.engine'),
                    key: 'engine'
                },
                {
                    title: this.$t('alarms.database.instanceType'),
                    key: 'type'
                },
                {
                    title: this.$t('alarms.database.state'),
                    key: 'stateName'
                },
                {
                    title: this.$t('alarms.database.region'),
                    key: 'region'
                },
                {
                    title: this.$t('common.operation'),
                    slot: 'actions'
                }],
                queryDatabaseByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableDatabases = this
        },
        mounted: function () {
            tableDatabases.queryDatabasesByGroupId();
        },
        methods: {
            // 数据库列表
            queryDatabasesByGroupId: function () {
                tableDatabases.$api.alertRuleExceptionResource.listAlertRuleExceptionResource({
                    "ticketCompanyMonitorItemVariablesId": this.$route.query.id,
                    "monitorModule": this.$route.query.monitorModule
                })
                .then(res => {
                    this.modalLoading = false
                    if(res.data){
                        this.queryDatabaseByGroupIdList = res.data;
                    }else{
                        this.queryDatabaseByGroupIdList=[];
                    }
                })
            },
            // 显示所有数据
            showAllDatabase: function () {
                tableDatabases.queryDatabasesByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.Name = this.queryDatabaseByGroupIdList[index].name
            },
            // 删除database
            deleteDatabase: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                tableDatabases.$api.alertRuleExceptionResource.softDelete({
                    "ticketCompanyMonitorItemVariablesId":this.$route.query.id,
                    "resourceId":this.queryDatabaseByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        tableDatabases.queryDatabasesByGroupId();
                        this.isDisable = false;
                        this.databaseDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/exception_resource/rds/TableDatabases.vue